import React, { Component } from 'react';

export default class Circle extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M48.233,48.207c0.509,-0.707 1.494,-0.865 2.2,-0.356c0.705,0.51 0.864,1.492 0.355,2.199c-2.457,3.404 -6.44,5.523 -10.788,5.523c-4.343,0 -8.329,-2.119 -10.788,-5.521c-0.509,-0.707 -0.352,-1.691 0.355,-2.201c0.704,-0.509 1.688,-0.35 2.198,0.354c1.878,2.599 4.927,4.217 8.235,4.217c3.314,0 6.357,-1.618 8.233,-4.215Zm-20.907,-10.23c0,-1.658 -1.343,-3.001 -2.999,-3.001c-1.657,0 -3.001,1.343 -3.001,3.001c0,1.656 1.344,2.999 3.001,2.999c1.656,0 2.999,-1.343 2.999,-2.999Zm28.347,-3.001c-1.656,0 -2.999,1.343 -2.999,3.001c0,1.656 1.343,2.999 2.999,2.999c1.658,0 3.001,-1.343 3.001,-2.999c0,-1.658 -1.343,-3.001 -3.001,-3.001Z"/>
                <path d="M40,4.826c19.413,0 35.174,15.761 35.174,35.174c0,19.413 -15.761,35.174 -35.174,35.174c-19.413,0 -35.174,-15.761 -35.174,-35.174c0,-19.413 15.761,-35.174 35.174,-35.174Zm0,6.742c15.692,0 28.432,12.74 28.432,28.432c0,15.692 -12.74,28.432 -28.432,28.432c-15.692,0 -28.432,-12.74 -28.432,-28.432c0,-15.692 12.74,-28.432 28.432,-28.432Z"/>
              </g>
            </svg>
        )
    }
}
